import { render, staticRenderFns } from "./management-question-set-detail.vue?vue&type=template&id=4a5d3cf5&scoped=true"
import script from "./management-question-set-detail.vue?vue&type=script&lang=js"
export * from "./management-question-set-detail.vue?vue&type=script&lang=js"
import style0 from "./management-question-set-detail.vue?vue&type=style&index=0&id=4a5d3cf5&prod&lang=scss&scoped=true"
import style1 from "./management-question-set-detail.vue?vue&type=style&index=1&id=4a5d3cf5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5d3cf5",
  null
  
)

export default component.exports